import styled from 'styled-components'

export const inputFontSize = '14px'

export const StyledAddressModal = styled.div`
  div label {
    font-weight: 600;
  }

  input {
    min-height: 30px;
    font-size: ${inputFontSize};
    :focus {
      background-color: #fff;
      border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      outline: 0;
    }
    /* box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25); */
  }

  .required-field:after {
    content: '*';
    color: ${({ theme }) => theme.colors.primary};
    margin-left: 0.2rem;
  }

  .save-option {
    input {
      min-width: 16px;
      min-height: 16px;
      margin-right: 10px;
      cursor: pointer;
    }

    label {
      vertical-align: bottom;
      margin-bottom: 0.3rem;
      font-weight: normal;
      text-transform: uppercase;
      cursor: pointer;
    }

    .col-sm-12 {
      margin-top: 5px;
      font-size: 15px;
      display: flex;
    }
  }

  .dropdown:focus,
  .dropdown:focus-visible,
  .dropdown:hover {
    box-shadow: none;
    border: none;
  }

  .dropdown-menu {
    height: 250px;
    overflow-y: scroll;
  }
  .dropdown-title,
  .dropdown-item {
    font-weight: normal;
    color: #495057;
  }
  .dropdown-item.active,
  .dropdown-item:focus-visible,
  .dropdown-item:hover {
    outline: 0;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    color: #fff;
  }

  .form-text {
    font-size: 1.2rem;
    font-weight: bold;
  }
`
